import * as types from "./mutation-type";

export default {
    [types.SET_OPEN_CALENDAR](state, payload) {
        state.openCalendar = payload;
    }
};
